import axios from 'axios';
import { API_URL } from '../../../config';

// Function for getting unique investor types
const getUniqueInvestorTypes = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/investors/filters?fields=type`,
      { withCredentials: true }
    );

    const { type } = response.data;

    return type?.values ?? [];
  } catch (error) {
    console.error('Error fetching unique investor types:', error);
    return [];
  }
};

export default getUniqueInvestorTypes;
